import { AbstractView } from '../core/AbstractView';

export class MainView extends AbstractView {
	constructor(element: HTMLElement, name: string, initial: boolean = false) {
		super(element, name, initial);
	}
}
